var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "header",
    [
      _c(
        "div",
        { staticClass: "container d-flex justify-content-between" },
        [
          _c(
            "router-link",
            {
              staticClass: "align-middle",
              attrs: { to: { name: "homepage" } },
            },
            [
              _c("img", {
                staticClass: "logo",
                attrs: { src: require("../media/logo_crop.png"), alt: "UNTRR" },
              }),
            ]
          ),
          _c(
            "div",
            { staticClass: "navbar-wrapper d-flex" },
            [
              !_vm.loginStatus
                ? [
                    _c("div", {
                      staticClass: "icon profile-icon mr-4",
                      on: {
                        click: function ($event) {
                          return _vm.toogleContMenu()
                        },
                      },
                    }),
                  ]
                : _vm._e(),
              _vm.loginStatus
                ? [
                    _c(
                      "router-link",
                      { attrs: { to: { name: "account-data" } } },
                      [_c("div", { staticClass: "icon profile-icon mr-4" })]
                    ),
                  ]
                : _vm._e(),
              _c(
                "router-link",
                { staticClass: "mr-4", attrs: { to: { name: "cart" } } },
                [
                  _c("div", { staticClass: "shopping-cart" }, [
                    _vm.cartCount() > 0
                      ? _c("div", { staticClass: "badge-count" }, [
                          _vm._v(" " + _vm._s(_vm.cartCount()) + " "),
                        ])
                      : _vm._e(),
                    _c("div", { staticClass: "icon cart-icon" }),
                  ]),
                ]
              ),
              _c("div", {
                staticClass: "icon hamburger-icon",
                on: {
                  click: function ($event) {
                    return _vm.toogleSideMenu()
                  },
                },
              }),
            ],
            2
          ),
        ],
        1
      ),
      _c("ContMenu"),
      _c("SideMenu"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }